import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=112ef984&scoped=true&"
import script from "./Recaptcha.vue?vue&type=script&lang=js&"
export * from "./Recaptcha.vue?vue&type=script&lang=js&"
import style0 from "./Recaptcha.vue?vue&type=style&index=0&id=112ef984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112ef984",
  null
  
)

export default component.exports